<template>
  <div>
    <v-dialog
      v-model="confirmationDialog"
      content-class="call-request-confirmation-dialog-container"
      persistent
      :max-width="isMobile ? '90dvw' : '560px'"
    >
      <v-card class="call-request-confirmation-card">
        <div class="card-inner">
          <v-icon class="card-close" color="black" @click.stop="exitDialog">{{
            icons.mdiClose
          }}</v-icon>
          <div class="dialog-header">Your call request has been logged.</div>
          <v-card-text class="dialog-info">
            <p>
              One of our <span>friendly call-center agents will walk you through</span> setting up your online will <span>in a few easy steps</span> soon.
            </p>
          </v-card-text>
          
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mdiClose } from "@mdi/js";
import { CREATE_WEBSITE_LEAD_MUTATION } from "../../../constants/graphql/website-leads";
import GradientButton from "../GradientButton.vue";

export default {
  name: "CallRequestConfirmationDialog",
  components: {
    GradientButton,
  },
  props: {
    showConfirmationDialog: {
      required: true,
      default: false,
      type: Boolean,
    },
    leadData: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      icons: {
        mdiClose: mdiClose,
      },
    };
  },
  computed: {
    confirmationDialog: {
      get() {
        return this.showConfirmationDialog;
      },
      set(value) {
        this.$emit("update:showConfirmationDialog", value);
      },
    },
    isMobile() {
      return this.$isMobileDevice();
    },
  },
  methods: {
    async submitLeadData() {
      try {
        const result = await this.$apollo.mutate({
          mutation: CREATE_WEBSITE_LEAD_MUTATION,
          variables: { websiteLeadInput: this.leadData },
        });
      } catch (error) {
        console.error("Error submitting lead data:", error);
      }
    }
  },
  watch: {
    showConfirmationDialog: {
      handler(newVal) {
        if (newVal && this.leadData) {
          this.submitLeadData();
        }
      },
      immediate: true
    }
  }
};
</script>

<style scoped lang="scss">
.call-request-confirmation-dialog-container {
  .call-request-confirmation-card {
    position: relative;
    .card-close {
      position: absolute;
      top: 40px;
      right: 30px;
    }
    .card-inner {
      display: flex;
      flex-direction: column;
      padding: 74px 30px 40px 30px;

      .dialog-header {
        font-size: 22px;
        font-weight: 600;
        line-height: 26.82px;
        margin-bottom: 16px;
      }

      .dialog-info {
        padding: 0;
        p {
          font-size: 16px;
          font-weight: 400;
          line-height: 22px;
        }
        span {
          font-size: 16px;
          font-weight: 600;
          line-height: 22px;
        }
      }
    }
  }
}
</style> 